// JavaScript Document
$(function () {
/*
======================
BODY FADE IN
======================
*/

	setTimeout(function () {
		$(".page-load").addClass("fade-out");
	}, 100);

	setTimeout(function () {
		$("body").addClass("loaded");
	}, 1200);

/*
===============================
ADDITIONAL BODYCLASSES
===============================
*/

	if (navigator.userAgent.indexOf("Safari") != -1 && navigator.userAgent.indexOf("Chrome") == -1) {
		$("html").addClass("safari");
	}

	/*
================================
SCROLL ANIMATIONS (WOW JS)
================================
*/

	var wow = new WOW({
		boxClass: "wow",
		animateClass: "animated",
		offset: 0,
		mobile: true,
		live: true,
		scrollContainer: null,
		resetAnimation: false,
	});
	wow.init();

	/*
=========================
OBJECT FIT
=========================
*/

	$(function () {
		objectFitImages("img.object-fit");
	});

	/*
=====================
TEL LINKS
=====================
*/

	//Disable on desktop (non touch)...
	$(".no-touchevents a.tel").on("click", function (e) {
		e.preventDefault();
	});

	/*
=====================
TABLE WRAPPER
=====================
*/

	$("table").wrap('<div class="table-wrap"></div>');

	/*
======================
IFRAME WRAPPER
======================
*/

	$(".page-section iframe").wrap('<div class="iframe-wrap"></div>');

	/*
===============================
FIXED HEADER
===============================
*/

	let lastScrollTop = 0;

	//add header class
	$(window).on("scroll", function () {
		let scrollTop = $(this).scrollTop();

		// Add "scrolled" class when not at the top
		if (scrollTop > 1) {
			$("#masthead").addClass("scrolled");
		} else {
			$("#masthead").removeClass("scrolled");
		}

		// Determine scroll direction
		if (scrollTop > lastScrollTop) {
			// Scrolling Down
			$("#masthead").removeClass("scrolling-up").addClass("scrolling-down");
		} else if (scrollTop < lastScrollTop) {
			// Scrolling Up
			$("#masthead").removeClass("scrolling-down").addClass("scrolling-up");
		}

		// Remove scrolling direction classes if at the very top
		if (scrollTop === 0) {
			$("#masthead").removeClass("scrolling-up scrolling-down");
		}

		lastScrollTop = scrollTop;
	});

	// On page load, check scroll position
	if ($(window).scrollTop() > 1) {
		$("#masthead").addClass("scrolled");
	}

	/*
======================
HAMBURGER MENU
======================
*/

	//open menu
	$(".menu-toggle").on("click", function () {
		$("body").toggleClass("mobile-navigation--open");
		$(this).toggleClass("active");
		$(".mobile-navigation").toggleClass("active");
	});

	$("#mobile-navigation .menu-item-has-children").append('<div class="menu-expand"><i class="fa-light fa-chevron-down"></i></div>');

	$(".menu-expand").on("click", function () {
		$(this).toggleClass("active");
		$(this).parent("li").toggleClass("active");
		$(this).parent("li").toggleClass("sub-menu-open");
		$(this).parent("li").find("> ul.sub-menu").slideToggle(600);
	});

	//hover class
	$(".main-menu ul li")
		.on("mouseenter", function () {
			$(this).addClass("active-hover");
		})
		.on("mouseleave", function () {
			$(this).removeClass("active-hover");
		});

	$(".main-menu .close").on("click", function () {
		$(".hamburger").removeClass("active");
		$(".main-menu").removeClass("active");
	});

	/*
================================
MENU AIM
================================
*/

	var $menu = $(".main-menu ul");

	$menu.menuAim({
		activate: activateSubmenu,
		deactivate: deactivateSubmenu,
	});

	function activateSubmenu(row) {
		var $row = $(row),
			$submenu = $row.children("ul");

		$row.children("a").addClass("hover");
		$submenu.css({display: "block"});
	}

	function deactivateSubmenu(row) {
		var $row = $(row),
			$submenu = $row.children("ul");

		$row.find("a").removeClass("hover");
		$submenu.css("display", "none");
	}

	$(document).click(function () {
		$(".main-menu ul li a.hover").removeClass("hover");
	});



	/*
=======================================
RESPONSIVE DATA TABLES
======================================
*/

	var tables = document.querySelectorAll(".page-section .table-wrap table");
	for (var a = 0; a < tables.length; a++) {
		var headertext = [];
		var headers = tables[a].querySelectorAll("thead td"),
			tablebody = tables[a].querySelector("tbody");

		for (var i = 0; i < headers.length; i++) {
			var current = headers[i];
			headertext.push(current.textContent.replace(/\r?\n|\r/, ""));
		}
		for (var i = 0, row; (row = tablebody.rows[i]); i++) {
			for (var j = 0, col; (col = row.cells[j]); j++) {
				col.setAttribute("data-th", headertext[j]);
			}
		}
	}

	
	/*
=================================
FANCYBOX
=================================
*/


	$("[data-fancybox]").fancybox({
		autoFocus: false,
		touch: false,
		compact: false,
		beforeShow: function () {
			$("html").addClass("fancybox-opened");
			$("body").css("overflow", "hidden");
		},
		afterClose: function () {
			$("html").removeClass("fancybox-opened");
			$("body").css("overflow", "");
		},
	});

	// Prevent clicking from causing a scroll
	$("[data-fancybox]").on("click", function (e) {
		e.preventDefault();
	});


	/*
======================================
SMOOTH SCROLL
======================================
*/

	// SMOOTH SCROLLING FROM ANOTHER PAGE TO CORRECT ID
	//START AT TOP OF PAGE AND SCROLL DOWN ALWAYS
	/*if (window.location.hash) {
		setTimeout(function () {
			$("html, body").scrollTop(0).show();
			$("html, body").animate(
				{
					scrollTop: $(window.location.hash).offset().top - 0,
				},
				1000
			);
		}, 0);
	} else {
		$("html, body").show();
	}*/

	//SMOOTH SCROLLING
	// Select all links with hashes
	$('a[href*="#"]')
		// Remove links that don't actually link to anything
		.not('[href="#"]')
		.not('[href="#0"]')
		.not('[data-fancybox]')
		.click(function (event) {
			// On-page links
			if (location.pathname.replace(/^\//, "") == this.pathname.replace(/^\//, "") && location.hostname == this.hostname) {
				// Figure out element to scroll to
				var target = $(this.hash);
				target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
				// Does a scroll target exist?
				if (target.length) {
					// Only prevent default if animation is actually gonna happen
					event.preventDefault();
					$("html, body").animate(
						{
							scrollTop: target.offset().top - 80,
						},
						1000,
						function () {
							// Callback after animation
							// Must change focus!
						}
					);
				}
			}
		});

	/*
=========================
ACCORDION
=========================
*/

	$(".accordion-item .toggle-header").on("click", function () {
		$(this).parent(".accordion-item").toggleClass("active");
		$(this).next(".toggle-content").slideToggle("slow");
	});

	/*
=========================
UP ARROW
=========================
*/

	$(".up").on("click", function (event) {
		event.preventDefault();
		$("body,html").animate({scrollTop: 0}, 1000);
	});

	/*
==========================
BUTTONS
==========================
*/

	if ($("p .button").length > 0) {
		$("p").each(function () {
			if ($(this).find(".button").length === 2) {
				$(this).addClass("two-buttons");
			}
		});
	}

	/*
==========================
SLIDERS
==========================
*/

	//Banner Slider
	var swiper1 = new Swiper(".banner-slider .swiper", {
		/*navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},*/
		autoplay: true,
		loop: true,
		effect: "fade",
		slidesPerView: 1,
		spaceBetween: 50,
		centeredSlides: true,
		centeredSlidesBounds: true,
		navigation: false,
		pagination: {
			el: ".banner-slider .swiper-pagination",
		},
	});

	$(".swiper-wrap").each(function (index, element) {
		var $this = $(element);

		// Find elements inside this swiper-wrap only
		var swiperEl     = $this.find(".swiper")[0];
		var nextBtn      = $this.find(".swiper-button-next")[0];
		var prevBtn      = $this.find(".swiper-button-prev")[0];
		var paginationEl = $this.find(".swiper-pag")[0];

		// Create a new swiper tied to this wrapper
		new Swiper(swiperEl, {
			slidesPerView: 1,
			autoplay: false,
			loop: false,
			spaceBetween: 30,
			navigation: {
				nextEl: nextBtn,
				prevEl: prevBtn,
			},
			pagination: {
				el: paginationEl,
				clickable: true,
			},
			breakpoints: {
				768: {
					slidesPerView: 2,
					spaceBetween: 30,
				},
				1024: {
					slidesPerView: 3,
					spaceBetween: 30,
				},
				1200: {
					slidesPerView: 3,
					spaceBetween: 30,
				},
			},
		});
	});

	//Large Slider - Full
	var $full = $(".swiper-full");

	var swiperFull = new Swiper($full.find(".swiper")[0], {
		spaceBetween: 0,
		slidesPerView: 1,
		autoplay: false,
		loop: false,
		navigation: {
			nextEl: $full.find(".swiper-button-next")[0],
			prevEl: $full.find(".swiper-button-prev")[0],
		},
		pagination: {
			el: $full.find(".swiper-pag")[0],
			clickable: true,
		},
	});


	//reviews carousel
	var swiper2 = new Swiper(".reviews-carousel", {
		slidesPerView: 1,
		spaceBetween: 50,
		centeredSlides: false,
		centeredSlidesBounds: false,
		loop: true,
		navigation: {
			nextEl: ".reviews-carousel .swiper-button-next",
			prevEl: ".reviews-carousel .swiper-button-prev",
		},
		pagination: {
			el: ".reviews-carousel .swiper-pagination",
		},
		breakpoints: {
			680: {
				slidesPerView: 1,
				spaceBetween: 40,
			},
			850: {
				slidesPerView: 2,
				spaceBetween: 80,
			},
			1280: {
				slidesPerView: 3,
				spaceBetween: 80,
			},
		},
	});

	//Single Page Related Content
	/*var swiper5 = new Swiper(".related__swiper", {
		slidesPerView: 1,
		spaceBetween: 0,
		navigation: {
			nextEl: ".reviews .swiper-button-next",
			prevEl: ".reviews .swiper-button-prev",
		},
		pagination: {
			el: ".swiper-pag-4",
		},
		breakpoints: {
			600: {
				slidesPerView: 2,
				spaceBetween: 20,
			},
			1200: {
				slidesPerView: 3,
				spaceBetween: 30,
			},
			1600: {
				slidesPerView: 3,
				spaceBetween: 20,
			},
		},
	});*/

	const thumbSlider = new Swiper('.thumb-slider', {
		spaceBetween: 10,
		slidesPerView: 5,
		freeMode: true,
		watchSlidesProgress: true,
		observer: true,
		observeParents: true,
	});

	const mainSlider = new Swiper('.gallery-slider', {
		spaceBetween: 10,
		slidesPerView: 1,
		loop: true,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		pagination: {
			el: ".swiper-pag",
		},
		thumbs: {
			swiper: thumbSlider,
		},
		observer: true,
		observeParents: true,
	});

	/*
==========================
RECAPTCHA FADEOUT
==========================
*/

	$(window).on("scroll", function () {
		var documentHeight = $(document).height();
		var windowHeight = $(window).height();
		var scrollPosition = $(window).scrollTop();

		if (documentHeight - (windowHeight + scrollPosition) < 100) {
			$(".grecaptcha-badge").addClass("fade");
		} else {
			$(".grecaptcha-badge").removeClass("fade");
		}
	});


	/*
==========================
FILTERS
==========================
*/

	$('#annexes-filters select').on('change', function() {
        $(this).closest('form').submit();
    });

	$("#news-filters select").on("change", function () {
        this.form.submit();
    });


/*
=============================
HERO IFRAME AND POSTER	
=============================
*/

function heroIframePosterFade() {
	const $hero = jQuery('.hero-iframe');
  if (!$hero.length) return;

  const $poster = jQuery('.image-wrap');
  if (!$poster.length) return;

  const getActiveIframe = () => {
    const $desktop = $hero.find('.desktop iframe:visible');
    if ($desktop.length) return $desktop;
    return $hero.find('.mobile iframe:visible');
  };

  const handleIframeReady = () => {
    const $iframe = getActiveIframe();
    if (!$iframe.length) return;

    $iframe
      .off('load.heroFade')
      .on('load.heroFade', function () {
        // Wait for first frame to render
        setTimeout(() => {
          $poster.fadeOut(500);
        }, 350); // ← critical delay
      });
  };

  handleIframeReady();

  let resizeTimer;
  jQuery(window).on('resize.heroFade orientationchange.heroFade', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(handleIframeReady, 200);
  });
}
//heroIframePosterFade();


/*
===============================
BANNER POPUP
===============================
*/

  	(function($) {
		var $wrapper = $('.popup-wrapper');
		if ($wrapper.length) {

			var $popup = $wrapper.find('.banner-popup');
			if (!$popup.length) return;

			function closePopup() {
				$wrapper.fadeOut(300, function() {
					$(window).trigger('resize');
				});
				sessionStorage.setItem('bannerPopupClosed', 'true');
			}

			$popup.find('.close').on('click', function(e) {
				e.stopPropagation();
				closePopup();
			});

			$wrapper.on('click', function(e) {
				if (window.innerWidth >= 850) return;
				if ($(e.target).closest('.banner-popup').length) return;

				closePopup();
			});
		}
	})(jQuery);


	/*
==========================
AJAX
==========================
*/

	//LOAD MORE POSTS
	/*$(".news-posts .posts-container").on("click", ".load-more", function (e) {
		e.preventDefault();

		var loaded = $("input.post-count").val();

		$.ajax({
			url: "/wp-admin/admin-ajax.php",
			type: "POST",
			data: {
				action: "load_more_posts",
				already_loaded: loaded,
			},
			beforeSend: function () {
				$(".news-posts .posts-container .load-more-posts").fadeTo(600, 0, function () {
					$(".news-posts .posts-container .load-more-posts").html('<div class="load"></div>');
				});
				$(".news-posts .posts-container .load-more-posts").delay(300).fadeTo(400, 1);
			},
			success: function (data) {
				$(".news-posts .posts-container .load-more-posts")
					.delay(1000)
					.fadeOut(700, function () {
						$(".news-posts .posts-container .load-more-posts").remove();
						$(".news-posts .posts-container").append(data);
					});
			},
		});
	});*/
}); //end document.ready
